module.exports = __webpack_public_path__ + "static/photo-8-2906552d8d844716b8813be662f02779.jpg";